import { Application } from 'stimulus';
import { definitionsFromContext } from 'stimulus/webpack-helpers';
import $ from 'jquery';

// Start Stimulus
const application = Application.start();
const context = require.context('./controllers', true, /\.js$/);
application.load(definitionsFromContext(context));

$(document).on("gform_confirmation_loaded", function () {
  dataLayer.push({event: 'Form Submitted'});
});
